/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from "react";
import { Disclosures } from "types";

const DisclosuresContext = createContext({
  disclosures: {},
  setDisclosures: (disclosures: Disclosures) => {},
  disclosuresInCorrectOrder: [{ attributes: {} }, undefined],
});

export { DisclosuresContext };
